

export function getTimeZoneOffsetFormatted() {
    const offset = -new Date().getTimezoneOffset();
    const sign = offset >= 0 ? "+" : "-";
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
    return `UTC${sign}${hours}:${minutes}`;
}

export function getTimeZoneName() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}